<script>
import Radio from "@/pages/components/form/horizontal/radio.vue";
import FormGroup from "@/pages/components/form/horizontal/form-group.vue";
import formInput from "@/mixins/shared/formInput";
import MultipleRadios from "@/pages/components/form/input-only/multiple-radios.vue";
import MultipleChecksProps from "@/mixins/shared/multipleChecksProps";

export default {
	mixins: [formInput, MultipleChecksProps],
	components: {MultipleRadios, Radio, FormGroup},
	props: {
		formGroupClasses: {
			type: String,
			default: ''
		}
	}
}
</script>
<template>
	<FormGroup :group-classes="formGroupClasses">
		<template #label v-if="$slots.label">
			<slot name="label" />
		</template>

		<template #label v-if="!$slots.label && label">
			{{ label }}
		</template>

		<MultipleRadios
			v-bind="$attrs"
			:form="form"
			:model-value="modelValue"
			:name="name"
			:options="options"
			@update:modelValue="changeModelValueTo"
			:ajax-url="ajaxUrl"
			:layout="layout"
		>
			<template #descriptionbottom v-if="$slots.descriptionbottom"><slot name="descriptionbottom" /></template>
		</MultipleRadios>

	</FormGroup>
</template>